import React from "react";
import styles from "./Badge.module.scss";

export default function Badge({variant = "primary", children, pillShape = true, className = "", size = "md", ...rest}) {
  return (
    <span
      {...rest}
      variant={variant}
      data-fs={size}
      className={`${styles.badge} ${pillShape ? "rounded-pill" : styles.square} ${className}`}>
      {children}
    </span>
  );
}
